<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Gender Select"
    seFeDataSubtitle="A gender selector"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for gender select inputs</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-gender-select-example></se-po-gender-select-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
